import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionListItemType } from 'features/sessions/config/types';
import { SessionSprint } from 'features/sprint';

export const useCoachSessionsQuery = () => {
  const { email: userId } = useParams();
  const { request } = useQueryHTTPRequest();

  return useQuery<
    { coachingSessions: SessionListItemType[] },
    unknown,
    { sessions: SessionListItemType[] }
  >(
    [queryKeys.coachSessions, userId],
    () =>
      request({
        url: `/api/coach/clients/${userId}/coaching-sessions`,
      }),
    {
      select: ({ coachingSessions, ...data }) => ({
        ...data,
        sessions: coachingSessions.map((session) => ({
          ...session,
          sprintDetails:
            session.sprintDetails && new SessionSprint(session.sprintDetails),
        })),
      }),
    }
  );
};
